import { defineComponent, openBlock, createElementBlock, normalizeClass, unref, renderSlot } from 'vue';
import { RowContainerAlign } from './row-container-align.enum.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "row-container",
  props: {
    align: { default: () => RowContainerAlign.CENTER }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["se-row-container", {
          "se-row-container-start": __props.align === unref(RowContainerAlign).START,
          "se-row-container-end": __props.align === unref(RowContainerAlign).END,
          "se-row-container-center": __props.align === unref(RowContainerAlign).CENTER,
          "se-row-container-between": __props.align === unref(RowContainerAlign).BETWEEN,
          "se-row-container-around": __props.align === unref(RowContainerAlign).AROUND,
          "se-row-container-evenly": __props.align === unref(RowContainerAlign).EVENLY
        }])
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 2);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=row-container.vue.js.map
